import { GENERIC_ERROR_SEND } from '@disco/constants/ActionTypes'
/**
 * Sends a generic error action for global error handling.
 * @param error - Error object to send through the error handling system
 * @returns Action object containing the error for reducer processing
 */
export const sendGenericError = (
  error: Error,
): {
  error: Error
  type: string
} => {
  console.error(error)
  return {
    type: GENERIC_ERROR_SEND,
    error,
  }
}
